<template>
  <div :class="classes" class="form-item__field">
    <div class="input-group input-group-booking-detail input-height">
      <label class="input-label input-group-addon" :class="highlight ? 'input-highlight' : null">{{ label }}</label>
      <div class="form-control input-height input-container">
        <p v-if="!editing" :class="highlight ? 'highlight-text' : null">
          <span v-if="booking.date_options">
            <span v-for="(option, index) in booking.date_options" :key="index">
              {{ option | date($user.date_format_preference) }},
            </span>
          </span>
          <span v-else-if="booking.date_start && booking.date_end">{{ booking.date_range }}</span>
          <span v-else>{{ booking.date | date($user.date_format_preference) }}</span>
        </p>
        <div v-else>
          <div>
            <flat-pickr
              v-model="date"
              :config="dateConfig"
              class="form-control"
              placeholder="DD/MM/YYYY"
              name="date">
            </flat-pickr>
          </div>
          <div>
            <flat-pickr
              v-model="date2"
              :config="dateConfig"
              class="form-control"
              placeholder="DD/MM/YYYY"
              name="date2">
            </flat-pickr>
          </div>
          <div>
            <flat-pickr
              v-model="date3"
              :config="dateConfig"
              class="form-control"
              placeholder="DD/MM/YYYY"
              name="date3">
            </flat-pickr>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import FlatPickr from 'vue-flatpickr-component'
import moment from 'moment-timezone'
import { BookingStateMapper as stateMapper } from 'pickstar-common'

export default {
  mixins: [stateMapper],
  data () {
    return {
      dateConfig: {
        altInput: true,
        altFormat: 'd/m/Y',
        dateFormat: 'Y-m-d',
        wrap: true,
        disable: [
          (date) => {
            if (this.$userIsAdmin) {
              return false
            }

            return moment(date).isBefore(moment().startOf('day'))
          }
        ]
      }
    }
  },

  components: {
    FlatPickr
  },

  props: {
    label: {
      required: true,
      type: String
    },
    classes: {
      required: false,
      default: '',
      type: String
    },
    highlight: {
      required: false,
      default: false,
      type: Boolean
    },
    booking: {
      required: true,
      type: Object
    },
    propertyMutator: {
      required: true,
      type: Function
    }
  },

  computed: {
    ...mapState('editing', ['editing']),

    date: {
      get () {
        return this.booking.date
      },
      set (value) {
        this.propertyMutator({
          property: 'date',
          value
        })
      }
    },

    date2: {
      get () {
        return this.booking.date2
      },
      set (value) {
        this.propertyMutator({
          property: 'date2',
          value
        })
      }
    },

    date3: {
      get () {
        return this.booking.date3
      },
      set (value) {
        this.propertyMutator({
          property: 'date3',
          value
        })
      }
    }
  }
}
</script>
